import { useState, type ReactNode } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { EstadoCarregando, EstadoErro, EstadoVazio } from '../../layout/Shell.tsx';
import { useTextos } from './i18n.ts';

export function useAcao() {
  const [erro, setErro] = useState(false);
  const [ocupado, setOcupado] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const qc = useQueryClient();
  return {
    erro,
    ocupado,
    sucesso,
    executar: async <T,>(fn: () => Promise<T>): Promise<T | undefined> => {
      setErro(false);
      setSucesso(false);
      setOcupado(true);
      try {
        const r = await fn();
        await qc.invalidateQueries({ queryKey: ['integracoes'] });
        setSucesso(true);
        return r;
      } catch {
        setErro(true);
        return undefined;
      } finally {
        setOcupado(false);
      }
    },
  };
}
export function Consulta<T>({ consulta, vazio, children }: {
  consulta: ReturnType<typeof useQuery<T>>;
  vazio: boolean;
  children: ReactNode;
}) {
  const t = useTextos();
  if (consulta.isPending)
    return <EstadoCarregando texto={t.carregando} />;
  if (consulta.isError)
    return <>
      <EstadoErro titulo={t.erro} texto={t.atualizar} />
      <button
        type="button"
        disabled={consulta.isFetching}
        onClick={() => void consulta.refetch()}
      >
        {t.atualizar}
      </button>
    </>;
  return <>
    {vazio && <EstadoVazio titulo={t.vazio} texto={t.vazioTexto} />}

    {' '}
    {children}
  </>;
}
export function Feedback({ acao }: {
  acao: ReturnType<typeof useAcao>;
}) {
  const t = useTextos();
  return <>
    {acao.erro && <EstadoErro titulo={t.erro} texto={t.atualizar} />}

    {' '}
    {acao.ocupado && <EstadoCarregando texto={t.carregando} />}

    {' '}
    {acao.sucesso && <p role="status">
      {t.sucesso}
    </p>}
  </>;
}
export function Segredo({ valor, fechar }: {
  valor: string;
  fechar: () => void;
}) {
  const t = useTextos();
  const [copiado, setCopiado] = useState(false);
  return <aside className="integracoes__segredo">
    <p>
      {t.avisoChave}
    </p>
    <pre>
      {valor}
    </pre>
    <button
      type="button"
      onClick={() => {
        void navigator.clipboard.writeText(valor).then(() => setCopiado(true));
      }}
    >
      {copiado ? t.sucesso : t.copiar}
    </button>
    <button type="button" onClick={fechar}>
      {t.fecharSegredo}
    </button>
  </aside>;
}
export function estadoTexto(estado: string, t: ReturnType<typeof useTextos>) {
  const mapa: Record<string, string> = {
    desconectado: t.desconectado,
    conectado: t.conectado,
    expirado: t.expirado,
    erro: t.falhou,
    ativa: t.ativa,
    pausada: t.pausada,
    desativada: t.desativada,
    pendente: t.pendente,
    entregue: t.entregue,
    esgotado: t.esgotado,
  };
  return mapa[estado] ?? estado;
}
